// src/components/ProtectedRoute.js

import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const ProtectedRoute = ({ children }) => {
  const { auth } = useContext(AuthContext);

  console.log("ProtectedRoute: checking authentication", auth);

  // Aquí verifica si el usuario está autenticado
  if (!auth.isAuthenticated) {
    console.log("ProtectedRoute: User not authenticated, redirecting to /login");
    return <Navigate to="/login" replace />;
  }

  console.log("ProtectedRoute: User authenticated, rendering children");
  return children; // Si está autenticado, renderiza los hijos
};

export default ProtectedRoute;
